module.exports = __webpack_public_path__ + "img/home-module8.611d1b09.png";